import React from "react";
import assetPath from "~/utils/assetPath";
import LinkComponent from "~/components/LinkComponent";

export function pictureContainer(picture, idx) {
  return (
    <div key={idx} className="picture_container">
      <div className="images_container">
        <img
          className="lazyload"
          data-src={picture.urls ? picture.urls.regular : ''}
        />
        <LinkComponent
          to={`/puzzles/${picture.id}`}
          addQueryParameters={true}
          className="shadow_overlay"
          data-href={`/puzzles/${picture.id}`}
          onClick={event => { this.handleLinkClick(event) }}
        >
          <div className="text_overlay">
            <img alt="Start puzzle" src={assetPath("play_large", "png")} />
            <p>Start puzzle</p>
          </div>
        </LinkComponent>
        <span className="credit_overlay">Photo by <a href={`${picture.user.links.html}?utm_source=Online%20Jigsaw%20Puzzles&utm_medium=referral`} target="_blank">{picture.user.name}</a> on <a href="https://unsplash.com/" target="_blank">Unsplash</a></span>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/collections/components/CollectionComponent/helpers/elements.js